import "./styles.css"
import { useEffect, useState } from "react";
import { IOptionsEvaluation } from "../../ViewTables/Index";
import TableVisualizationRowTask from "./TableVisualizationRow/Index";
import ViewTasks from "../../Tasks/ViewTasks";
import { Loading } from "../../Loading/Index";
import { ReactComponent as ArrowIcon } from "../../../assets/svg/icons/rightChevron.svg"
import { useTableMonitor } from "../../../hooks/useTableMonitor";

interface TableProductsProps {
  listTable: ITaskEvaluation[];
  filter: IOptionsEvaluation | undefined;
  isLoading: boolean;
}

export default function TableTaskEvaluation({ listTable, isLoading }: TableProductsProps) {
  const [selectedId, setSelectedId] = useState(0);
  const { selectedOrder, setSelectedOrder, sortAsc, setSortAsc } = useTableMonitor();

  useEffect(() => {
    setSelectedOrder("createdAt")
  }, []);

  return (
    <>
      <>
        {listTable && listTable.length > 0 ?
          <>
            <section className="tableHeaderColumnTaskEvaluation">
              {[
                { key: "createdByUser.name", label: "Usuário" },
                { key: "type", label: "Tarefa" },
                { key: "microAreaInitials", label: "Pasto/Lote" },
                { key: "state", label: "Status" },
                { key: "createdAt", label: "Data Criação" },
                { key: "updatedAt", label: "Data Execução" },
              ].map(({ key, label }) => (
                <div
                  key={key}
                  onClick={() => {
                    setSelectedOrder(key);
                    if (selectedOrder != key) {
                      setSortAsc(false)
                      return
                    };
                    setSortAsc(!sortAsc);
                  }}
                  className="infoColumn"
                >
                  {label}
                  <ArrowIcon
                    className={`iconSort${sortAsc ? "--asc" : ""}`}
                    style={{
                      display: selectedOrder === key ? "block" : "none",
                    }}
                  />
                </div>
              ))}
              <div />
            </section>

            <section
              className="tableViewRows"
              style={{
                position: "relative",
              }}
            >
              <Loading visible={isLoading} />

              {listTable.map(evaluation =>
                <TableVisualizationRowTask evaluation={evaluation} setSelectedId={setSelectedId} />
              )}
            </section>
          </>
          :
          isLoading
            ?
          <div className="emptyTable_container">
            <Loading visible={true} />
          </div>
          :
          <div className="emptyTable_container">
            <span> Nenhum resultado encontrado.</span>
          </div>
        }
      </>

      <ViewTasks
        selected={selectedId}
        setSelectedId={setSelectedId}
      />
    </>
  )
}